// @flow
import React from "react";

import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import CurrentRequestOperations from "../../../Store/Ducks/CurrentRequest/operations";
import CrossCancel from "../../CrossCancel/CrossCancel";
import Screens from "../../../Store/Views/screens";

type ConnectedProps = {
    showingOriginTerminals: boolean,
    cancelOriginTerminals: () => mixed,
    cancelDestTerminals: () => mixed,
}

const CancelTerminalSelection = (props: ConnectedProps) => {
    const clickHandler = props.showingOriginTerminals ? props.cancelOriginTerminals : props.cancelDestTerminals;
    return (
        <CrossCancel onCrossClick={clickHandler}/>
    );
};

const mapStateToProps = (state, props) => {
    return {
        showingOriginTerminals: Screens.shouldShowSelectTerminalOrigin(state),
    };
};

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            cancelOriginTerminals: CurrentRequestOperations.cancelOriginTerminalSelectionClick,
            cancelDestTerminals: CurrentRequestOperations.cancelDestTerminalSelectionClick,
        },
        dispatch);
};

export default connect(mapStateToProps, mapActionsToProps)(CancelTerminalSelection);



// WEBPACK FOOTER //
// ./src/Components/TopBar/CancelTerminalSelection/CancelTerminalSelection.js